import React from 'react';
import { Col, Row, Container } from 'react-bootstrap';

const Body = () => (
  <div>
    <Container fluid>
      <Row>
        <Col className="px-0">
          <div className="banner" style={{ backgroundImage: 'url(/images/lilicats-banniere.jpg)' }}>
            <div className="banner-content">
              <h1 className="primary-heading">Garde de chats &&nbsp;Transport félin</h1>
              <h2 className="secondary-heading">
                autour de La Londe-les-Maures (20 km)
              </h2>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-0" md="6">
          <div className="bloc-content bloc-content-primary">
            <h3 className="primary-heading mb-4">Qui suis-je ?</h3>
            <p className="content px-3 px-md-5">
              Titulaire de l&apos;ACACED (Attestation de connaissances
              pour les animaux de compagnie d&apos;espèces domestiques)
              et amoureuse des chats,
              j&apos;aime plus que tout m&apos;occuper d&apos;eux et les comprendre.
              Après des années au Canada, je reviens dans ma région natale et démarre
              mon activité de catsitting.
              Adepte du trail running et de photographie, j&apos;aime
              passer du temps sur les chemins de nature et derrière
              mon objectif quand je ne suis pas auprès de vos chats !
              <br />
              <br />
              Aurélie &#128571;
            </p>
          </div>
        </Col>
        <Col className="px-0" md="6">
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats-aurelie.jpg)' }} />
        </Col>
      </Row>
      <Row>
        <Col className="px-0">
          <div className="bloc-content bloc-content-secondary">
            <h3 className="primary-heading mb-3">Les visites à domicile</h3>
            <p className="content px-3 px-md-5">
              Choisissez la formule de garde idèale pour votre chat :
              {' '}
              <strong>une visite standard</strong>
              {' '}
              ou
              {' '}
              <strong>une visite longue.</strong>
              <br />
              Des visites deux fois par jour peuvent être organisées sur devis,
              en fonction des besoins spécifiques de votre chat.
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-0" md="6">
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats-1.jpg)' }}>
            <div>
              <h2 className="primary-heading heading-with-bg">Formules</h2>
            </div>
          </div>
        </Col>
        <Col className="px-0" md="6">
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats-tarifs-visites_ao.jpg)' }} />
        </Col>
      </Row>
      <Row>
        <Col className="px-0">
          <div className="bloc-content bloc-content-secondary">
            <h3 className="primary-heading mb-3">Disponibilité</h3>
            <p className="content px-3 px-md-5">
              Les visites sont assurées 7 jours sur 7
              et
              les jours fériés de 7 h à 19 h.
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-0" md="6">
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats-frais-kilometriques_ai.jpg)' }} />
        </Col>
        <Col className="px-0" md="6" xs={{ order: 'first' }} lg={{ order: 'last' }}>
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats-3.jpg)' }}>
            <div>
              <h2 className="primary-heading heading-with-bg">Frais de déplacement</h2>
            </div>
          </div>
        </Col>
      </Row>
      {/* <Row>
        <Col className="px-0">
          <div className="bloc-content bloc-content-secondary">
            <h3 className="primary-heading mb-3">Le petit + Lilicats</h3>
            <p className="content px-3 px-md-5">
              Votre félin est une vraie boule d&apos;énergie quand vous rentrez du travail ?
              Ou au contraire, rien ne l&apos;amuse ?
              <br />
              Offrez-lui des
              {' '}
              <strong>séances de jeu</strong>
              {' '}
              avec Lilicats !
              J&apos;apporte avec moi jouets et accessoires qui suciterons
              l&apos;intêret de votre animal.
              <br />
              En jouant, le chat décharge une partie de ses émotions et vide ses batteries
              ce qui améliore son comportement en général.
              C&apos;est aussi un moyen efficace de le maintenir en bonne forme physique !
              Et cela, à tous les âges !
            </p>
          </div>
        </Col>
      </Row> */}
      {/* <Row>
        <Col className="px-0" md="6">
          <div className="img-bloc"
          style={{ backgroundImage: 'url(/images/lilicats-tarifs-visitesjeu_ac.jpg)' }} />
        </Col>
        <Col className="px-0" md="6" xs={{ order: 'first' }} lg={{ order: 'last' }}>
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats.jpg)' }}>
            <div>
              <h2 className="primary-heading heading-with-bg">Tarifs</h2>
            </div>
          </div>
        </Col>
      </Row> */}
      <Row>
        <Col className="px-0">
          <div className="bloc-content bloc-content-secondary">
            <h3 className="primary-heading mb-3">Remise selon la durée</h3>
            <p className="content px-3 px-md-5">
              <strong>7 à 13 jours </strong>
              : 5 % de réduction
              <br />
              <strong>14 jours et plus </strong>
              : 8 % de réduction
              <br />
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-0" md="6">
          <div className="bloc-content bloc-content-primary">
            {/* <h3 className="primary-heading mb-4">Frais supplémentaires</h3> */}
            <ul className="content px-3 px-md-5">
              <li>
                <span className="list-item-title">Remise et restitution des clés</span>
                0 à 5 km : 18&nbsp;€
                {' '}
                <br />
                5 à 10 km : 24&nbsp;€
                {' '}
                <br />
                Jusqu&apos;à 20 km : 30&nbsp;€
                {' '}
                <br />
                <br />
                <span className="text-underline">Offertes</span>
                {' '}
                si les déplacements sont faits par vos&nbsp;soins
                <br />
              </li>
              <li>
                <span className="list-item-title">NACs / nouveaux animaux de compagnie</span>
                1,50&nbsp;€ / par animal supplémentaire / visite
                <br />
              </li>
              <li>
                <span className="list-item-title">Horaire de visite spécifique / soin programmé</span>
                3&nbsp;€ / visite
                <br />
              </li>
              <li>
                <span className="list-item-title">
                  Jours fériés
                  <sup> *</sup>
                  <br />
                </span>
                +100 % du tarif de base (hors déplacement)
                <br />
              </li>
              <li>
                <span className="list-item-title">Réapprovisionnement d&apos;appoint</span>
                10&nbsp;€ + montant des achats
                <br />
              </li>
              {/* <li>
                <span className="list-item-title">Déplacement vétérinaire</span>
                30&nbsp;€ + montant des honoraires
                <br />
              </li> */}
              <span className="list-item-title-light">
                <sup>* </sup>
                jour de l&apos;an, lundi de pâques, fête du travail,
                victoire&nbsp;1945, ascension, pentecôte, fête nationale,
                assomption, toussaint,
                armistice&nbsp;1918, jour de noël
              </span>
            </ul>
          </div>
        </Col>
        <Col className="px-0" md="6" xs={{ order: 'first' }} lg={{ order: 'last' }}>
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats.jpg)' }}>
            <div>
              <h2 className="primary-heading heading-with-bg">Les à côtés</h2>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-0">
          <div className="bloc-content bloc-content-secondary">
            <h3 className="primary-heading mb-3">Transport félin</h3>
            <p className="content px-3 px-md-5">
              Je propose un service de transport sécurisé pour vos félins,
              idéal pour les rendez-vous vétérinaires.
              Je prends soin de votre chat tout au long du trajet,
              avec calme et attention.
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-0" md="6">
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats-tarifs-transport-félin-aa.jpg)' }} />
        </Col>
        <Col className="px-0" md="6">
          <div className="img-bloc" style={{ backgroundImage: 'url(/images/lilicats-4.jpg)' }} />
        </Col>
      </Row>
    </Container>
  </div>

);

export default Body;
